import { library } from '@fortawesome/fontawesome-svg-core';

// Import specific icons you want to use
import {
  faUser,
  faHome,
  faSearch,
  faBars,
  faTimes,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faPlus,
  faMinus,
  faEdit,
  faTrash,
  faSave,
  faCheck,
  faExclamationTriangle,
  faInfoCircle,
  faSpinner,
  faEye,
  faEyeSlash,
  faCog,
  faSignOutAlt,
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faCalendar,
  faClock,
  faHeart,
  faStar,
  faShare,
  faDownload,
  faUpload,
  faFilter,
  faSort,
  faSortUp,
  faSortDown,
  faTag,
  faArrowUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faChartBar,
  faBox,
  faFolder,
  faExchangeAlt,
  faChartLine,
  faBookmark,
  faTools,
  faUserShield,
  faMinusCircle,
  faPlusCircle,
  // Navigation icons
  faTachometerAlt,
  faCubes,
  // Additional useful icons
  faWarehouse,
  faBoxes,
  faShoppingCart,
  faClipboardList,
  faFileAlt,
  faImage,
  faPlay,
  faPause,
  faStop,
  faForward,
  faBackward,
  faVolumeUp,
  faVolumeDown,
  faVolumeMute,
  faBell,
  faBellSlash,
  faSync,
  faRedo,
  faUndo,
  faCopy,
  faCut,
  faPaste,
  faLink,
  faUnlink,
  faLock,
  faUnlock,
  faKey,
  faShield,
  faDatabase,
  faServer,
  faCloud,
  faCloudDownloadAlt,
  faCloudUploadAlt,
  faWifi,
  faPrint,
  faQrcode,
  faBarcode,
  faIdCard,
  faAddressCard,
  faBusinessTime,
  faHandshake,
  faUsers,
  faUserTie,
  faUserCog,
  faUserEdit,
  faUserPlus,
  faUserMinus,
  faUserCheck,
  faUserTimes,
  faBuilding,
  faIndustry,
  faStore,
  faShoppingBag,
  faCreditCard,
  faMoneyBillWave,
  faCoins,
  faReceipt,
  faCalculator,
  faChartPie,
  faChartArea,
  faProjectDiagram,
  faSitemap,
  faNetworkWired,
  faRoute,
  faMapMarked,
  faMapPin,
  faCompass,
  faGlobe,
  faLanguage,
  faFlag,
  faFlagCheckered,
  faTrophy,
  faMedal,
  faAward,
  faCertificate,
  faGraduationCap,
  faBook,
  faBookOpen,
  faJournalWhills,
  faNewspaper,
  faFileInvoice,
  faFileContract,
  faFileSignature,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faFileImage,
  faFileVideo,
  faFileAudio,
  faFileArchive,
  faFileCode,
  faTerminal,
  faCode,
  faCodeBranch,
  faBug,
  faRocket,
  faAtom,
  faCogs,
  faWrench,
  faHammer,
  faToolbox,
  faPalette,
  faPaintBrush,
  faFill,
  faHighlighter,
  faEraser,
  faRuler,
  faRulerCombined,
  faSquare,
  faCircle,
  faShapes,
  faVectorSquare,
  faObjectGroup,
  faObjectUngroup,
  faLayerGroup,
  faClone,
  faStamp,
  faCrop,
  faExpandArrowsAlt,
  faCompressArrowsAlt,
  faSearchPlus,
  faSearchMinus,
  faWandMagicSparkles
} from '@fortawesome/free-solid-svg-icons';

import {
  faHeart as farHeart,
  faStar as farStar,
  faUser as farUser,
  faEnvelope as farEnvelope,
  faCalendar as farCalendar,
  faClock as farClock,
  faCalendarDays as farCalendarDays
} from '@fortawesome/free-regular-svg-icons';

import {
  faFacebook,
  faTwitter,
  faInstagram,
  faLinkedin,
  faGithub,
  faGoogle
} from '@fortawesome/free-brands-svg-icons';

// Add icons to the library
library.add(
  // Solid icons
  faUser,
  faHome,
  faSearch,
  faBars,
  faTimes,
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faPlus,
  faMinus,
  faEdit,
  faTrash,
  faSave,
  faCheck,
  faExclamationTriangle,
  faInfoCircle,
  faSpinner,
  faEye,
  faEyeSlash,
  faCog,
  faSignOutAlt,
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faCalendar,
  faClock,
  faHeart,
  faStar,
  faShare,
  faDownload,
  faUpload,
  faFilter,
  faSort,
  faSortUp,
  faSortDown,
  faTag,
  faArrowUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faChartBar,
  faBox,
  faFolder,
  faExchangeAlt,
  faChartLine,
  faBookmark,
  faTools,
  faUserShield,
  faMinusCircle,
  faPlusCircle,
  // Navigation icons
  faTachometerAlt,
  faCubes,
  // Additional useful icons
  faWarehouse,
  faBoxes,
  faShoppingCart,
  faClipboardList,
  faFileAlt,
  faImage,
  faPlay,
  faPause,
  faStop,
  faForward,
  faBackward,
  faVolumeUp,
  faVolumeDown,
  faVolumeMute,
  faBell,
  faBellSlash,
  faSync,
  faRedo,
  faUndo,
  faCopy,
  faCut,
  faPaste,
  faLink,
  faUnlink,
  faLock,
  faUnlock,
  faKey,
  faShield,
  faDatabase,
  faServer,
  faCloud,
  faCloudDownloadAlt,
  faCloudUploadAlt,
  faWifi,
  faPrint,
  faQrcode,
  faBarcode,
  faIdCard,
  faAddressCard,
  faBusinessTime,
  faHandshake,
  faUsers,
  faUserTie,
  faUserCog,
  faUserEdit,
  faUserPlus,
  faUserMinus,
  faUserCheck,
  faUserTimes,
  faBuilding,
  faIndustry,
  faStore,
  faShoppingBag,
  faCreditCard,
  faMoneyBillWave,
  faCoins,
  faReceipt,
  faCalculator,
  faChartPie,
  faChartArea,
  faProjectDiagram,
  faSitemap,
  faNetworkWired,
  faRoute,
  faMapMarked,
  faMapPin,
  faCompass,
  faGlobe,
  faLanguage,
  faFlag,
  faFlagCheckered,
  faTrophy,
  faMedal,
  faAward,
  faCertificate,
  faGraduationCap,
  faBook,
  faBookOpen,
  faJournalWhills,
  faNewspaper,
  faFileInvoice,
  faFileContract,
  faFileSignature,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFilePowerpoint,
  faFileImage,
  faFileVideo,
  faFileAudio,
  faFileArchive,
  faFileCode,
  faTerminal,
  faCode,
  faCodeBranch,
  faBug,
  faRocket,
  faAtom,
  faCogs,
  faWrench,
  faHammer,
  faToolbox,
  faPalette,
  faPaintBrush,
  faFill,
  faHighlighter,
  faEraser,
  faRuler,
  faRulerCombined,
  faSquare,
  faCircle,
  faShapes,
  faVectorSquare,
  faObjectGroup,
  faObjectUngroup,
  faLayerGroup,
  faClone,
  faStamp,
  faCrop,
  faExpandArrowsAlt,
  faCompressArrowsAlt,
  faSearchPlus,
  faSearchMinus,
  faWandMagicSparkles,

  // Regular icons
  farHeart,
  farStar,
  farUser,
  farEnvelope,
  farCalendar,
  farClock,
  farCalendarDays,

  // Brand icons
  faFacebook,
  faTwitter,
  faInstagram,
  faLinkedin,
  faGithub,
  faGoogle
);